import { api } from './api';
import type { ApiSite, ApiShift } from '../types';

export const settingsService = {
  async getSites(): Promise<ApiSite[]> {
    const { data } = await api.get<{ data: ApiSite[] }>('/me/app-sites');
    return data.data ?? [];
  },

  async getMyShifts(): Promise<ApiShift[]> {
    const { data } = await api.get<{ data: ApiShift[] }>('/me/shifts');
    return data.data ?? [];
  },
};
